<template>
  <div class="subscribe">
    <div id="mc_embed_signup" class="input-wrap">
      <form class="form" target="_blank" :action="susbscribeURL" method="post" ref="form">
        <input class="input" type="email" name="EMAIL"
         v-model="email" placeholder="your@email.here" required>
        <button @click="submit()" :disabled="!isValid">Subscribe</button>
        <div style="position: absolute; left: -5000px;" aria-hidden="true">
          <input type="text" name="b_1721978482d033f9ccdfbcec5_33e39a4b41" tabindex="-1" value="">
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import isEmail from '@/utilities/isEmail';

export default {
  name: 'Subscribe',
  data() {
    return {
      email: null,
      susbscribeURL: 'https://jandcomic.us10.list-manage.com/subscribe/post?u=1721978482d033f9ccdfbcec5&amp;id=33e39a4b41',
    };
  },
  computed: {
    isValid() {
      return isEmail(this.email);
    },
  },
  methods: {
    submit() {
      this.$refs.form.submit();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/input.scss';

form {
  display: flex;
}
button {
  margin-left: 10px;
}
</style>
